import type { ManagedPersonStatus } from "#shared/managePeopleContract.ts";
import type { BadgeProps } from "@/components/ui/badge.tsx";
import { CheckIcon, ClockIcon, NoSymbolIcon, UserPlusIcon, XMarkIcon } from "@heroicons/react/24/outline";
import type { ComponentType, SVGProps } from "react";

export const PERSON_STATUS_BADGE_INTENT: Record<ManagedPersonStatus, BadgeProps["intent"]> = {
    active: "success",
    created: "secondary",
    invited: "warning",
    deactivated: "danger",
    nonSeat: "outline"
};

export const PERSON_STATUS_ICON: Record<ManagedPersonStatus, ComponentType<SVGProps<SVGSVGElement>>> = {
    active: CheckIcon,
    created: UserPlusIcon,
    invited: ClockIcon,
    deactivated: XMarkIcon,
    nonSeat: NoSymbolIcon
};
